.bodyLocked {
  overflow: hidden;
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.overlay {
  position: fixed;
  z-index: 100000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  color: var(--pm-grey1);
  cursor: wait;
  overscroll-behavior: contain;
  touch-action: none;
  outline: none;
}

.darkOverlay {
  background: rgba(14, 15, 20, 0.6);
  color: var(--pm-white);
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    margin-top: 0;
    margin-bottom: 0;
  }

  h1 {
    margin: 0;
    color: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.25rem;
  }
}
